import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import { PageHeader } from 'antd';
import './Page2.css';
import { DatePicker, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { DataGrid, GridApi, GridCellParams, GridToolbar } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { UIStore } from "../store/store";
import roundToNearestMinutes from 'date-fns/esm/fp/roundToNearestMinutes/index.js';

const Room: React.FC = (props: any) => {

  //fetching from store(PullState)
  const currentRoom = UIStore.useState(s => s.SelectedProperty);

  const [roomData, SetRoomData] = useState([]);

  const { name } = useParams<{ name: string; }>();

  const columns = [

    { field: 'id', headerName: 'ID', width: 120 },
    { field: 'created', headerName: 'DATE CREATED', width: 190 },
    { field: 'Name', headerName: 'NAME', width: 170 },
    { field: 'MonthlyRent', headerName: 'RENT', width: 120, },
    { field: 'Address', headerName: 'ADDRESS', width: 370 },
    { field: 'numberofrooms', headerName: 'ROOMS', width: 130 },
    { field: 'Description', headerName: 'DESCRIPTION', width: 170 },
    { field: 'PropertyType', headerName: 'TYPE', width: 170 },
    { field: 'PropertyUses', headerName: 'USAGE', width: 170 },
    { field: 'FurnishedType', headerName: 'FURNISHING', width: 170 },
    {
      field: 'details', headerName: 'DETAILS', width: 190,
      renderCell: (params:any) => {
      return(
      <strong>
       <Link to={{ pathname: "/RoomDetails"}}  >
          <Button
            variant="contained"
            color="primary"
            size="small"    
            onClick={()=>{
               //updating the store(PullState) Room value
              UIStore.update((s, o) => {
                s.SelectedProperty = params.row;
              });
            }}       
            style={{ marginLeft: 25 }} > View Details </Button>       
       </Link>
             </strong>)},
    },
  ];

  useIonViewDidEnter(() => {

    axios.get('https://dev.northroom.co.za/api/bizprop/properties/all')
      .then(function (response) {
        // handle success
        SetRoomData(response.data);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
      
  });

  return (

    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              title="Room"
            />
          </IonRow>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="20" style={{ paddingLeft: "0px" }}>
                <IonCard>
                  <IonCardHeader>
                  </IonCardHeader>
                  <IonCardContent>      
                    <div style={{ height: 400, width: '82vw', paddingRight: "2vw" }}>
                      <DataGrid
                        rows={roomData}
                        columns={columns}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        filterModel={{
                          items: [
                            { columnField: 'Name', operatorValue: 'contains', value: '' },
                          ],
                        }}                    
                      />
                    </div>                                           
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>
  );
};

export default Room;